
/* isMat
 * マテリアル名から形状を判別.
 */
export class isMat {
    static glass(name: string) { return name.match(/glass/); }
    static metal(name: string) { return name.match(/kanamono/); }
    static entryDoor(name: string) { return name.match(/ent-body/); }
    static door(name: string) { return name.match(/door-body/); }
    static bath(name: string) { return name.match(/bath/); }
    static sashBody(name: string) { return name.match(/sash-body/) || name.match(/sash-gakubuti/); }
    static garageBody(name: string) { return name.match(/shutter-body/); }
    static curtain(name: string) { return name.match(/sash-curtain/); }

    static floor(name: string) { return name.match(/floor/); }
    static tatamiFloor(name: string) { return name.match(/^(rom11)(?=.*floor)/); }
    static stairs(name: string) { return name.match(/^(?=.*(kekomi|fumiita))/); }
    static fumiita(name: string) { return name.match(/^(?=.*fumiita)/); }
    static kekomi(name: string) { return name.match(/^(?=.*kekomi)/); }
    static kabe(name: string) { return name.match(/^(?=.*kabe)/); }
    static habaki(name: string) { return name.match(/^(?=.*habaki)/); }
    static innerWallCeiling(name: string) {
        return name.match(/^(?=.*rom)(?=.*(wall|kosi|ceiling))/);
    }
    static innerWall(name: string) {
        return name.match(/^(?=.*rom)(?=.*(wall|kosi|falling))/);
    }
    static column(name: string) {
        return name.match(/^(?=.*col)(?=.*(wall|kosi))/);
    }
    static shadow(name: string) {
        return name.match(/^(?=.*rom)(?=.*(shadow_wall|shadow_floor|shadow_ceiling|shadow_entrance))/);
    }
    static wallShadow(name: string) {
        return name.match(/^(?=.*rom)(?=.*(shadow_wall))/);
    }
    static generalShadow(name: string) {
        return name.match(/^(?=.*rom)(?=.*(shadow_floor|shadow_ceiling|shadow_entrance))/);
    }
    static ceiling(name: string) {
        return name.match(/^(?=.*rom)(?=.*(ceiling|wall_btm))/);
    }
    static girder(name: string) {
        return name.match(/^(?=.*rom)(?=.*(girder))/)
    }
    static sagari(name: string) {
        return name.match(/^(?=.*rom)(?=.*(wall_btm))/);
    }

    // 屋根.
    static roof(name: string) {
        return name == 'out01-roof' || name == 'out02-roof' || name == 'out03-roof';
    }
    // 端.
    static hana(name: string) {
        return name == 'out01-hana' || name == 'out02-hana' || name == 'out03-hana' ||
            name == 'out01-nokiura' || name == 'out02-nokiura' || name == 'out03-nokiura';
    }
    // 棟.
    static mune(name: string) {
        return name == 'out01-mune' || name == 'out02-mune' || name == 'out03-mune';
    }
    // 妻.
    static tuma(name: string) {
        return name == 'out01-tuma' || name == 'out02-tuma' || name == 'out03-tuma';
    }
    // 外壁.
    static outerWall(name: string) {
        return name == 'out01-wall' || name == 'out02-wall' || name == 'out03-wall';
    }
    static outerWallN(name: string, floor: number) {
        return ((name == 'out01-wall') && (floor == 1)) || ((name == 'out02-wall') && (floor == 2)) || ((name == 'out03-wall') && (floor == 3));
    }
    // 外壁腰.
    static outerWallKosi(name: string) {
        return name == 'out01-kosi' || name == 'out02-kosi' || name == 'out03-kosi';
    }
    // 外壁腰.
    static kosiFloorFromMatName(name: string) {
        if (!isMat.outerWallKosi(name)) return 0;
        return Number(name.match(/out0(1|2|3)-kosi/)[1]);
    }
    static outerWallKosiN(name: string, floor: number) {
        return ((name == 'out01-kosi') && (floor == 1)) || ((name == 'out02-kosi') && (floor == 2)) || ((name == 'out03-kosi') && (floor == 3));
    }
    static mizukiri(name: string) {
        return name == 'out01-mizukiri';
    }
    // バルコニー.
    static balcony(name: string) {
        return name == 'out02-balcony' || name == 'out03-balcony';
    }
    static balconyN(name: string, floor: number) {
        return ((name == 'out02-balcony') && (floor == 2)) || ((name == 'out03-balcony') && (floor == 3));
    }
    //　幕板.
    static makuita(name: string) { return name.match(/makuita/); }
    //　窓枠
    static madowaku(name: string) { return name.match(/madowaku/); }
    //　ティンバー.
    static timber(name: string) { return name.match(/timber/); }
    //　笠木
    static kasagi(name: string) { return name.match(/kasagi/); }
    //　切断面.
    static section(name: string) {
        return name == 'out01-wall-section' || name == 'out02-wall-section' || name == 'out03-wall-section';
    }
    static section2(name: string) { return name.match(/^(?=.*rom)(?=.*section)/); }
    // 玄関床.
    static entrance(name: string) { return name.match(/^(?=.*-entrance)/); }
    // ポーチ.
    static porch(name: string) {
        return name == 'out01-porch';
    }
    // 基礎.
    static base(name: string) {
        return (name == 'out01-base') || (name.match(/^base.*mat/));
    }
    // 敷地.
    static site(name: string) {
        return name == 'out01-site';
    }
    // 目地.
    static meji(name: string) {
        return name.match(/meji/);
    }
    // 斜線規制.
    static setback(name: string) {
        return (name == 'out00-limit') || (name == 'setback_mat');
    }
    // 道路のライン(道路より先に確認).
    static line(name: string) {
        return name.match(/road_center/);
    }
    // 道路.
    static road(name: string) {
        return name.match(/road/);
    }
    // 移動時、当たり判定用の不可視の壁
    static virtualWall(name: string) {
        return name.match(/virtualWall/);
    }
}
